const BarChart3 = ({ size=24, color="#12a87a", ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-chart-column-icon lucide-chart-column"
        {...props}
    >
        <path d="M3 3v16a2 2 0 0 0 2 2h16"/>
        <path d="M18 17V9"/>
        <path d="M13 17V5"/>
        <path d="M8 17v-3"/>
    </svg>
);

export default BarChart3;
